import Pusher from 'pusher-js';

export const pusher = new Pusher('814c2b3c49d3c0bf68e0', {
  cluster: 'eu',
});
